import React from 'react';
import { makeStyles, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function GreenButton(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    return <Button className={classes.greenButton} disabled={props.disabled} onClick={props.onClick}>
            {props.text}
    </Button>
}

const useStyles = makeStyles({   
    greenButton: {
        width: "100%",
        maxWidth:"300px",
        backgroundColor: FlagstoneTheme.palette.lightGreen.main,
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        borderRadius: "6px",
        height: "40px",
        "&:hover": {
            background: FlagstoneTheme.palette.lightGreen.main
        },
    }
});